let imageEditorIdCounter = 0;

export function createImageEditorId(prefix = 'image'): string {
  imageEditorIdCounter += 1;
  return `${prefix}-${Date.now().toString(36)}-${imageEditorIdCounter.toString(36)}`;
}

export function safeImageEditorFileName(value: string, extension = 'png'): string {
  const base = value
    .trim()
    .replace(/[^a-z0-9._-]+/gi, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();

  return `${base || 'image-edit'}.${extension.replace(/^\./, '')}`;
}
